import { useTranslation } from "react-i18next";
import React, { FC } from "react";

import {
  Box,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from "@components/base";

const RecommendationsListSkeleton: FC = () => {
  const { t } = useTranslation();


return (
    <Card>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={3}
      >
        <Typography variant="subtitle1">{t("recommendationsList.title")}</Typography>
      </Stack>
      <CardContent>
        <Box p={3} pt={0}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <Skeleton variant="rounded" height={30} />
            </Grid>
            {Array.from({ length: 3 }).map((_, index) => (
              <Grid key={index} size={3}>
                <Skeleton variant="rounded" height={300} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default RecommendationsListSkeleton;
